import { Anchor } from 'components/ui';
import { useWhiteLabelContext } from 'components/white-label';
import { ETHENA_SUPPORT_EMAIL } from 'lib/constants';
import { ReactNode } from 'react';

interface ISupportEmailProps {
  children?: ReactNode;
  className?: string;
  subject?: string;
}

export const SupportEmail = ({
  children,
  className,
  subject,
}: ISupportEmailProps) => {
  const { supportEmail } = useWhiteLabelContext();

  const email = supportEmail || ETHENA_SUPPORT_EMAIL;
  const urlParams = subject ? `?subject=${subject}` : '';

  return (
    <Anchor
      className={className}
      href={`mailto:${email}${urlParams}`}
      target="_blank"
    >
      {children ?? email}
    </Anchor>
  );
};
